// @flow
import * as React from 'react';
import { useDispatch } from 'react-redux';

import { IntlActions } from 'common/redux/actions/intl';

import usePersonnel from 'common/hooks/usePersonnel';
import useClientId from 'common/hooks/useClientId';
import useEffectOnce from 'common/hooks/useEffectOnce';

const UnsetSelectedBusinessUnit = (): React.Node => {
    const clientId = useClientId();
    const personnel = usePersonnel();
    const dispatch = useDispatch();

    useEffectOnce(() => {
        dispatch(
            IntlActions.setSelectedBU({
                clientId,
                personnelId: personnel.personnelId,
                selectedBU: null
            })
        );
    });

    return null;
};

export default UnsetSelectedBusinessUnit;
